import classNames from "classnames/dedupe";
import React, { FC } from "react";
import { SvgIcon } from "../../Icons";
import { FilterIcon, FilterIconSmall } from "../../../icons";
import { CounterBadge } from "../../Atoms/CounterBadge";

export type TFilterButtonSize = "large" | "small";
export interface IFilterButtonProps {
  title: string;
  size?: TFilterButtonSize;
  count?: number;
  classes?: {
    root?: string;
  };
  onClick?(): void;
}

const FilterButton: FC<IFilterButtonProps> = ({
  size = "large",
  title,
  count = 0,
  classes,
  onClick,
}) => {
  const rootClasses = classNames(classes?.root, "btn btn-filter btn-block");

  return (
    <>
      {size === "small" && (
        <button type="button" className="btn" onClick={onClick}>
          <SvgIcon icon={FilterIcon} classes={{ root: "icon-filter" }} />
          {count > 0 && <CounterBadge count={count} />}
        </button>
      )}
      {size === "large" && (
        <button type="button" className={rootClasses} onClick={onClick}>
          {title}

          {count > 0 ? (
            <CounterBadge count={count} />
          ) : (
            <SvgIcon
              icon={FilterIconSmall}
              classes={{ root: "icon-container--small" }}
            />
          )}
        </button>
      )}
    </>
  );
};

export default FilterButton;
